import React from 'react';
import { Card, Button, Typography } from 'antd';
import { PlusOutlined, FundViewOutlined } from '@ant-design/icons'; 
import { useNavigate } from 'react-router-dom';

const { Title } = Typography;

const Dashboard = () => {
  const navigate = useNavigate();

  const handleCreateGame = () => {
    navigate('/dashboard/create-game');  // Redirects to create game form
  };

  const handleAccessGames = () => {
    navigate('/dashboard/games');  // Redirects to games list page
  };

  return (
    <div style={{ 
      minHeight: '100vh', 
      display: 'flex', 
      justifyContent: 'center', 
      alignItems: 'center',
      padding: '20px'
    }}>
      <div style={{ display: 'flex', gap: '20px' }}>
        {/* Create New Game Box */}
        <Card
          style={{ width: 300, textAlign: 'center', background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)' }}
          hoverable
          onClick={handleCreateGame}
        >
          <PlusOutlined style={{ fontSize: '48px', color: 'white' }} />
          <Title level={3}></Title>
          <Button 
            type="primary" 
            shape="round" 
            size="large" 
            ghost  // Make the button transparent
            style={{
              border: '1px solid white', // Ensure the border is white
              color: 'white', // Text color
            }}
          >
            Create a New Game
          </Button>
        </Card>

        {/* Access Existing Games Box */}
        <Card
          style={{ width: 300, textAlign: 'center', background: 'linear-gradient(135deg, #1890ff 0%, #722ed1 100%)' }}
          hoverable
          onClick={handleAccessGames}
        >
          <FundViewOutlined style={{ fontSize: '48px', color: 'white' }} /> 
          <Title level={3}></Title>
          <Button 
            type="primary" 
            shape="round" 
            size="large" 
            ghost  // Make the button transparent
            style={{
              border: '1px solid white', // Ensure the border is white
              color: 'white', // Text color
            }}
          >
            View Existing Games
          </Button>
        </Card>
      </div>
    </div>
  );
};

export default Dashboard;
